import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  const footerLinks = {
    solutions: [
      { name: 'Application Mobile', href: '/popup-photo' },
      { name: 'Borne Kiosque', href: '/popup-photo' },
      { name: 'Staffing', href: '/popup-photo' }
    ],
    company: [
      { name: t('footer.contact'), href: '/#contact' },
      { name: t('nav.partners'), href: '/#partners' }
    ],
    legal: [
      { name: t('footer.legal'), href: '#' },
      { name: t('footer.privacy'), href: '#' },
      { name: t('footer.terms'), href: '#' }
    ]
  };

  return (
    <footer data-testid="footer" className="relative bg-[#050505] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4 group" data-testid="footer-logo">
              <div className="relative">
                <div className="absolute inset-0 bg-[#FF7A00]/20 rounded-xl blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <img 
                  src="https://customer-assets.emergentagent.com/job_ifotolife-popup/artifacts/aoncqacu_ChatGPT%20Image%2028%20janv.%202026%2C%2014_08_19.png" 
                  alt="iFotoLife" 
                  className="h-14 w-auto relative z-10 drop-shadow-[0_0_10px_rgba(255,122,0,0.3)]"
                />
              </div>
            </Link>
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              {t('footer.description')}
            </p>
            {/* Social Links */}
            <div className="flex gap-3">
              {['Facebook', 'Instagram', 'LinkedIn'].map((social, i) => (
                <a 
                  key={i}
                  href="#"
                  data-testid={`social-${social.toLowerCase()}`}
                  className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-white/50 hover:text-[#FF7A00] hover:border-[#FF7A00]/30 transition-colors"
                >
                  <span className="text-xs font-bold">{social[0]}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="text-white font-semibold mb-4">Solutions</h4>
            <ul className="space-y-3">
              {footerLinks.solutions.map((link, i) => (
                <li key={i}>
                  <Link 
                    to={link.href}
                    className="text-white/50 hover:text-[#FF7A00] transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-4">Entreprise</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link, i) => (
                <li key={i}>
                  <Link 
                    to={link.href}
                    className="text-white/50 hover:text-[#FF7A00] transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.contact')}</h4>
            <div className="space-y-3 text-sm">
              <p className="text-white/50">+212 631 200 456</p>
              <p className="text-white/50">contact@ifotolife.com</p>
              <p className="text-white/50">www.ifotolife.org</p>
            </div>
            <div className="mt-6">
              <p className="text-white/50 text-xs mb-2">CEO: Samento</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} iFotoLife. {t('footer.rights')}.
          </p>
          <div className="flex gap-6">
            {footerLinks.legal.map((link, i) => (
              <Link 
                key={i}
                to={link.href}
                className="text-white/40 hover:text-white/60 transition-colors text-sm"
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
